import React, {useState} from "react";
import {getDescription} from "./CvParser";
import ValidatingInput from "./ValidatingInput.tsx";

const CvEditByte = ({data, value, onChange}) => {

    const {mode, possibleValues, number, ...rest} = data

    const readonly = data?.attributes?.mode === 'ro'

    const containerstyle = {
        margin: '5px',
    }

    const [val, setVal] = useState(0)
    function bitChanged(valx) {
        setVal(valx)
    }

    const inputstyle = {
        width: '100px',
        background: readonly ? '#cccccc' : '#FFFFFF',
        border: 'none',
    }

    let vls = possibleValues
    if( vls?.length > 20) {
        vls = possibleValues.substring(0, 20) + "..."
    }
    //<span>cv:{number} | BYTE | {getDescription(data)} | {vls} </span>
    return(
        <div style={containerstyle}>

            <ValidatingInput value={val} readOnly={readonly} onChange={(e) => bitChanged(e)} constraint={possibleValues} showBits={true}/>
        </div>
    )
}

export default CvEditByte;